import React from "react";
import { useTranslation } from "react-i18next";
import Hero from "src/components/Hero/Hero";
import TitleSection from "src/components/TitleSection/TitleSection";
import ReactMarkdown from "react-markdown";
import styled from "styled-components";
import { Col, Row } from "react-bootstrap";
import TournamentSubtabsContent from "src/pages/poker/tournaments/TournamentSubtabsContent";
import TournamentSectionalTabs from "src/components/SectionalTabs/TournamentSectionalTabs";
import { useHomepage } from "src/context/homepage/homepage.provider";
import { LuAlarmClock } from "react-icons/lu";
import { FaCircleQuestion } from "react-icons/fa6";
import EventFinished from "src/components/EventFinished";

const MultiMillionaireMakerSeptember2025 = () => {
  const { i18n, t } = useTranslation();
  const { tournamentsSubtabs } = useHomepage();
  const sectionalTabsContent = t(
    "multiMillionaireMakerSeptember2025.content.sectionalTabsContent",
    { returnObjects: true }
  );

  const dynamicSubTabs = sectionalTabsContent[`subTab${tournamentsSubtabs}`];
  return (
    <Div>
      <EventFinished scheduleKeyName="multiMillionaireMakerSeptember2025" eventType="promotion" />
      <Hero
        image={t("multiMillionaireMakerSeptember2025.hero.image")}
        bgImage={t("multiMillionaireMakerSeptember2025.hero.bgImage")}
        imageAlt={t("multiMillionaireMakerSeptember2025.hero.imageAlt")}
        fluidImage={"hero?.image" ? false : true}
      />
      <container-div>
        <TitleSection
          as={"h2"}
          title={t("multiMillionaireMakerSeptember2025.content.title")}
          text={t("multiMillionaireMakerSeptember2025.content.text")}
          borderColor="#cf3c22"
        />
        <Row className="pb-3 text-left d-flex justify-content-center periods">
          <Col xs={12} md={6}>
            <LuAlarmClock />
            <TitleSection
              as={"h3"}
              title={t("multiMillionaireMakerSeptember2025.content.drawDay.title")}
              text={t("multiMillionaireMakerSeptember2025.content.drawDay.text")}
              className="py-0"
              borderColor="#cf3c22"
            />
          </Col>
          <Col xs={12} md={6}>
            <FaCircleQuestion />
            <TitleSection
              as={"h3"}
              title={t("multiMillionaireMakerSeptember2025.content.howItWorks.title")}
              text={t("multiMillionaireMakerSeptember2025.content.howItWorks.text")}
              className="py-0 how-it-works"
              borderColor="#cf3c22"
            />
          </Col>
        </Row>
      </container-div>
      <container-div>
        <div className="tabContent my-4 pb-4">
          <ContentText>
            <TitleSection
              as={"h3"}
              title={t("multiMillionaireMakerSeptember2025.content.readyToBecome.title")}
              text={t("multiMillionaireMakerSeptember2025.content.readyToBecome.text")}
              className="py-0"
              borderColor="#cf3c22"
            />
          </ContentText>
          <TournamentSectionalTabs
            subTabs={t("multiMillionaireMakerSeptember2025.content.sectionalTabs", {
              returnObjects: true,
            })}
          />
          <TournamentSubtabsContent tournamentContent={dynamicSubTabs} />
        </div>
      </container-div>
    </Div>
  );
};
const Div = styled.div`
  --topspacing: 110px;
  --gradientheight: 40px;

  background-color: var(--lightblack);
  color: var(--white);
  text-align: center;
  overflow-x: hidden;
  height: auto;
  padding-bottom: 40px;
  .hero_text_container {
    display: none;
    padding: 0;
  }
  .hero_image_container {
    padding: 20px;
    img {
      max-height: 500px;
    }
  }
  .hero_container.fluid {
    min-height: 440px;
    @media (min-width: 768px) and (max-width: 991px) {
      --topspacing: 40px;
      --gradientheight: 20px;
    }
    @media (max-width: 768px) {
      min-height: 150px;
    }
    @media (min-width: 768px) {
      top: var(--topspacing);
      margin-bottom: var(--topspacing);
      /*
        This gives a black bar a the top, behind the nav
        and 40px of gradient overlying the banner image
      */
      &:before {
        background: linear-gradient(
          to bottom,
          rgba(0, 0, 0, 1) 0%,
          rgba(0, 0, 0, 1) 71.43%,
          rgba(0, 0, 0, 0) 100%
        );
        content: "";
        height: calc(var(--topspacing) + var(--gradientheight));
        top: calc(-1 * var(--topspacing));
        position: relative;
      }
    }
  }
  p,
  li {
    strong {
      color: #cf3c22;
    }
  }
  li {
    padding-bottom: 0.75rem;
  }
  .how-it-works li {
    list-style: none;
    &::before {
      content: "•";
      color: #cf3c22;
      font-weight: bold;
      display: inline-block;
      width: 1em;
      margin-right: 0.5em;
    }
  }
  div.periods {
    text-align: center;
    p {
      font-size: 16px;
      strong {
        color: unset;
      }
    }
    svg {
      margin: 20px 0 10px;
      color: #cf3c22;
      font-size: 40px;
    }
  }
  .left {
    text-align: left;
  }

  .sectional-tournament-tabs {
    justify-content: space-around;
    margin: 20px;
    width: calc(100% - 40px);
    button {
      min-height: unset;
      padding: 0.8rem;
      &.active {
        background-color: var(--white);
        color: var(--mutedred);
      }
      &:hover {
        background-color: var(--white);
        color: var(--mutedred);
      }
    }
    @media (min-width: 768px) {
      button {
        max-width: 24%;
      }
    }
  }
  a {
    /* color: #cf3c22; */
    &:hover {
      /* border-bottom: 1px solid #cf3c22; */
    }
  }
  .tabContent {
    background-color: var(--black);
  }
`;
const ContentText = styled.div`
  text-align: left;
  margin: 40px 0 20px 0;
  p {
    font-size: 16px !important;
  }
`;
export default MultiMillionaireMakerSeptember2025;